import apiFetch from '../apiFetch'

export default function (token) {
  return apiFetch({endPoint: `Combos/getProductosValidacionActivos`, method: 'GET', body: null, token: token})
}